import { render, staticRenderFns } from "./TaxReport.vue?vue&type=template&id=7f5befc8"
import script from "./TaxReport.vue?vue&type=script&lang=js"
export * from "./TaxReport.vue?vue&type=script&lang=js"
import style0 from "./TaxReport.vue?vue&type=style&index=0&id=7f5befc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports